<template>
  <div class="fintech-search">
    <v-icon>fas fa-search</v-icon>
    <span>
      <v-text-field
      v-model="searchWord"
      label=""
      placeholder="Fintech DB 検索"
      class="fintech-search-input"
      @keypress.enter="search"></v-text-field>
    </span>
  </div>
</template>

<script>
  const querystring = require('querystring')

  export default {
    data () {
      return {
        searchWord: '',
        searchCategory: '',
      }
    },

    methods: {

      search () {
        var url = '/fintechs?word=' + this.searchWord;

        if (this.searchCategory) {
          url = url + '&category=' + this.searchCategory;
        }

        location.href = url;
        return false;
      }
    },

    mounted () {
      if (location.search) {
        const search = location.search.replace('?', '')
        this.searchCategory = querystring.parse(search).category
        this.searchWord = querystring.parse(search).word
      }
    }
  };
</script>

<style lang="scss">
  @import '../../sass/variables';

  .fintech-search {
    display: flex;
    align-items: center;

    &-input {
      margin-left: 10px;
      width: 200px;
    }
  }
</style>
